import { useLocation } from 'react-router';

import { useAtomValue } from 'jotai';
import { ROUTES } from '../../../../../constants/RouteNameMapping';
import { usePortfolioRouteListener } from '../../../../../hooks/usePortfolioRouteListener';
import { useSelectedCurrency } from '../../../../../hooks/useSelectedCurrency';
import { ViewNavigationProvider } from '../../../../../pages/PortfolioOverview/components/ViewNavigation/ViewNavigationProvider';
import { selectedViewPFJ } from '../../../../../pages/PortfolioOverview/state/ViewStateJ';
import { defaultCurrency } from '../../../../../services/state/AppConfigStateJ';
import { NavigationWrapper } from '../NavigationWrapper';
import { ViewNavigation } from './ViewNavigation';

export const PortfolioReportingNavigation = () => {
  const { setSelectedCurrency, tempSwitchToAppCurrency } = useSelectedCurrency();
  const viewType = useAtomValue(selectedViewPFJ)?.viewType;
  const { pathname } = useLocation();

  usePortfolioRouteListener({
    onEnter: () => {
      tempSwitchToAppCurrency();
    },
    onExit: () => {
      setSelectedCurrency(defaultCurrency, false);
    },
    viewType: viewType,
  });

  if (!pathname.startsWith(`/${ROUTES.PORTFOLIO}`)) {
    return null;
  }

  return (
    <ViewNavigationProvider>
      <NavigationWrapper title={'Portfolio Reporting'}>
        <ViewNavigation />
      </NavigationWrapper>
    </ViewNavigationProvider>
  );
};
